import Model, { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import { pledgeFrequencyLabels } from 'donor-elf-web/lib/pledge-utils';

export default Model.extend({
  entityId: attr('string'),
  fundId: attr('string'),
  fundName: attr('string'),
  frequency: attr('number'),
  frequencyLabel: computed('frequency', function () {
    return pledgeFrequencyLabels[this.frequency];
  }),
  startDate: attr('date-only'),
  endDate: attr('date-only'),
  amount: attr('number'),
  notes: attr('string'),
});
